import styled from "styled-components";

export const TableStyle = styled.div`
  table {
    tbody{
        tr {
            :nth-child(3) {
                font-weight: bold;
            }    
            :nth-last-child(2) {
                font-weight: bold;
            }
            :nth-last-child(4) {
                font-weight: bold;
            }                           
            :last-child {
                td {
                    border-top: 5px double black;
                    font-weight: bold;
                }
            }
        }
    }
  }
`;
